import React from "react";
import { t } from "i18next";

const tabClass = (isActive) =>
    `px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap
    ${isActive ? "bg-[#147F26] text-white" : "text-gray-500 hover:text-gray-700 hover:bg-gray-100"}`;

export default function businessTabs(activeTabV, setActiveTabV) {
    return <>
        <button className={tabClass(activeTabV === "general")} onClick={() => setActiveTabV("general")}>
            {t('general')}
        </button>
        <button className={tabClass(activeTabV === "about")} onClick={() => setActiveTabV("about")}>
            {t('aboutCompany')}
        </button>
        <button className={tabClass(activeTabV === "contacts")} onClick={() => setActiveTabV("contacts")}>
            {t('contacts')}
        </button>
        <button className={tabClass(activeTabV === "design")} onClick={() => setActiveTabV("design")}>
            {t('decorations')}
        </button>
    </>;
}
